<template>
  <div class="weekActivity" id="weekActivity">
    <div class="container">
      <div class="title-top">
        <div class="title">
          <div class="one">{{message.styleTitle}}</div>
          <div class="describe">{{message.styleDescribe}}</div>
        </div>
        <div class="button-right" @click="toMore">
          <span>
            更多
            <i class="fa fa-plus" aria-hidden="true"></i>
          </span>
        </div>
      </div>

      <div class="content">
        <div class="rotation-left" @click="toDetail(bigItem.id)">
          <img :src="bigItem.linePictureUrl" class="left-img" />
          <div class="basic-information">
            <span class="label">{{ bigItem.price ? `￥${bigItem.price}` : '价格待定' }}</span>
            <div class="label-text">{{bigItem.lineTitile}}</div>
            <div class="info-bottom">
              <div>
                <span>
                  <i class="fa fa-clock-o" aria-hidden="true"></i>
                  {{fomateDate(bigItem.date)}}
                </span>
                <span class="weeek" :class="colorClass(bigItem.signUpStatus)" >{{bigItem.signUpStatus}}</span>
              </div>
            </div>
          </div>
        </div>

        <div
          class="rotation-right"
          v-for="(item,index) in smallList"
          :key="index"
          @click="toDetail(item.id)"
        >
          <div class="trans-img">
            <img :src="item.linePictureUrl" class="right-img" />
          </div>

          <div class="right-infoitem">{{item.lineTitile}}</div>
          <div class="info-describe">{{item.lineAbstract}}</div>
          <div class="right-infobottom">
            <div class="right-price">{{ item.price ? `￥${item.price}` : '价格待定' }}</div>
            <div class="right-sign">
              <div>{{fomateDate(item.date)}}</div>
              <div class="weeek" :class="colorClass(item.signUpStatus)">{{item.signUpStatus}}</div>
            </div>
          </div>
        </div>
        
        <!--当长度为3时，再添加一个小的元素充斥排版-->
        <div class="between-after" v-show="smallList.length === 3"></div>

      </div>
    </div>
  </div>
  <!-- aboutUs end -->
</template>

<script>
import axios from "axios";
import { fomateDate } from "@/util/util";

export default {
  name: "weekActivity",
  data() {
    return {};
  },
  props: {
    message: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  components: {},
  computed: {
    nav() {
      return this.$route.params.id;
    },
    basicInfo() {
      return this.$store.state.webInfo;
    },
    bigItem() {
      return this.message.linePageList[0].linePage[0];
    },
    smallList() {
      // const length = this.message.linePageList[0].linePage.length;
      return this.message.linePageList[0].linePage.slice(1, 5);
    },
    colorClass(status){
      return function(status){
        switch (status) {
          case '报名中':
            return 'green'
            break;
          case '已成行':
            return 'orange'
            break;
          case '已满员':
            return 'red'
            break;
        }
      }
    }
  },
  mounted() {},
  methods: {
    fomateDate,
    toDetail(id) {
      this.$router.push({
        path: "/activityDetail",
        query: { id: id }
      });
    },
    // toMore(){
    //   this.$router.push({ path: `activityIndex/0` });
    // },
    toMore() {
      this.$router.push({
        path: `/searchActivity`,
        query: {
          id: this.message.styleId,
          title: this.message.styleTitle
        }
      });
    }
  }
};
</script>

<style scoped>
.container {
  position: relative;
  background: #fff;
  text-align: left;
}
.title-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
/* 小标题 */
.title {
  margin: 20px 0;
}
.one {
  color: #007741;
  font-weight: bold;
  height: 30px;
  font-size: 16px;
}
.describe {
  border-top: 1px solid #cccccc;
  padding: 10px 0;
  color: #676767;
  font-size: 14px;
  width: 300px;
}
.button-right {
  cursor: pointer;
  width: 80px;
  height: 36px;
  font-size: 14px;
  line-height: 36px;
  text-align: center;
  border: 1px solid #cccccc;
  border-radius: 8px;
}
.content {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 20px;
}
.rotation-left {
  position: relative;
  width: 65%;
  height: 420px;
  margin-bottom: 20px;
  overflow: hidden;
  box-shadow: 0px 0px 10px #aaaaaa;
}
.left-img {
  width: 100%;
  height: 100%;
  transition: all 0.6s;
}
.left-img:hover {
  transform: scale(1.2);
}
.basic-information {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
  color: #fff;
  padding: 10px 30px;
}
.label {
  padding: 6px 12px;
  font-size: 13px;
  background: rgba(0, 0, 0, 0.8);
  line-height: 40px;
}
.label-text {
  height: 40px;
  line-height: 40px;
  border-top: 1px solid #ffffff;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.info-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
}
.right-infobottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
  align-items: center;
  font-size: 13px;
  position: absolute;
  bottom: 10px;
  left: 0;
  right: 0;
}
.weeek {
  display: inline-block;
  margin-left: 20px;
  /* background: #007640; */
  color: #fff;
  font-size: 14px;
  padding: 4px 12px;
  border-radius: 12px;
  cursor: pointer;
}
.rotation-right {
  position: relative;
  width: 30%;
  height: 420px;
  background: #faf7f7;
  padding-bottom: 41px;
  box-sizing: border-box;
  box-shadow: 0px 0px 10px #aaaaaa;
  margin-bottom: 20px;
}
.between-after{
  position: relative;
  height: 420px;
  padding-bottom: 41px;
  width: 30%;
  box-sizing: border-box;
}
/* .rotation-right:hover {
  box-shadow: 0px 0px 10px #aaaaaa;
} */
.rotation-right:hover .right-img{
    transform: scale(1.2);
}
.trans-img {
  width: 100%;
  height: 60%;
  overflow: hidden;
}
.right-img {
  width: 100%;
  height: 100%;
  transition: all 0.6s;
}
/* .right-img:hover {
  transform: scale(1.2);
} */
.right-infoitem,
.info-describe {
  padding: 0 12px;
}
.right-infoitem {
  font-size: 16px;
  font-weight: bold;
  line-height: 30px;
  height: 60px;
  overflow: hidden;
  text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  padding-top: 8px;
}
.info-describe {
  color: #676767;
  line-height: 25px;
}
.right-price {
  font-size: 24px;
  font-weight: bold;
  color: #ff6c00;
}
.right-sign {
  display: flex;
  align-items: center;
}
.green {
  background: #007640;
}
.orange {
  background: #ff6c00;
}
.red {
  background: rgb(211, 23, 23);
}
</style>



// WEBPACK FOOTER //
// src/components/home/weekActivity.vue